/* eslint-disable @typescript-eslint/no-explicit-any */
import { map, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { apiUrls } from "../core/constants/apiUrls.const";
import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DocumentDetails } from "../models/document.model";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
    private http = inject(HttpClient);

  getDocuments(): Observable<any> {
    return this.http
      .get<{ data: any }>(
        `${environment.base_url}${apiUrls.getDocument}`
      )
      .pipe(map((res) => res.data));
  }
  deleteDocuments(documentId: string): Observable<any> {
    return this.http.delete(`${environment.base_url}${apiUrls.getDocument}/${documentId}`);
  }
 getDocumentsById(id: string): Observable<DocumentDetails> {
    return this.http.get<{ data: DocumentDetails }>(`${environment.base_url}${apiUrls.getDocument}/${id}`)
      .pipe(map(res => res.data));
  }

  addDocuments(data: DocumentDetails): Observable<DocumentDetails> {
    return this.http.post<{ data: DocumentDetails }>(`${environment.base_url}${apiUrls.getDocument}`, data)
      .pipe(map(res => res.data));
  }

  updateDocuments(id: string, documentPayload: DocumentDetails): Observable<DocumentDetails> {
    return this.http.put<{ data: DocumentDetails }>(`${environment.base_url}${apiUrls.getDocument}/${id}`, documentPayload)
      .pipe(map(res => res.data));
  }

}
